export default "__VITE_ASSET__pzgXU9He__"